import React, { createContext, useContext, useEffect } from 'react';
import { useNotifications } from './useNotifications';

const NotificationContext = createContext();

export const useNotificationContext = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotificationContext must be used within a NotificationProvider');
  }
  return context;
};

export const NotificationProvider = ({ children }) => {
  const notificationHook = useNotifications();

  const value = {
    ...notificationHook,
    // Add any additional notification context methods here
  };

  return (
    <NotificationContext.Provider value={value}>
      {children}
      {/* Show quick test component in development */}
    </NotificationContext.Provider>
  );
};
